<template>
  <button @click="isOpen = !isOpen" class="flex items-center gap-3">
    <span class="italic text-sm"> {{ t(text) }} </span>
    <arrow-down
      class="transition-transform duration-500 rotate-0"
      :class="{ 'rotate-180': isOpen }"
    />
  </button>
  <div
    class="overflow-hidden transition-all duration-500 max-h-0"
    :class="{ 'max-h-[999px]': isOpen }"
  >
    <slot />
  </div>
</template>

<script setup>
import ArrowDown from '@/assets/ArrowDown.vue';
import { defineProps, ref } from 'vue';
import { useI18n } from 'vue-i18n';

defineProps({ text: { type: String, default: 'empty' } });
const { t } = useI18n();
const isOpen = ref(false);
</script>
